import PropTypes from "prop-types"
import DropdownMenu from "components/ui/DropdownMenu"
import { createRegistrationPaths } from "components/admin/Event/eventHelpers"
import CheckInsDropdownItem from "./CheckInsDropdownItem"

const AttendanceDropdown = ({
  apiBaseUrl,
  checkInsBaseUrl,
  eventAttendanceReportPath,
  event,
  attendeeCounts,
  assignmentTypes,
  isSimpleEvent,
  isActingAsStaff,
  baseParams,
  filterParams,
  subscribedToCheckIns,
  checkInsSettingsPath
}) => {
  const renderCheckIns = () => (
    <CheckInsDropdownItem
      event={event}
      apiBaseUrl={apiBaseUrl}
      checkInsBaseUrl={checkInsBaseUrl}
      assignmentTypes={assignmentTypes}
      subscribedToCheckIns={subscribedToCheckIns}
      checkInsSettingsPath={checkInsSettingsPath}
      isActingAsStaff={isActingAsStaff}
    />
  )

  const { requestPath: attendanceReportSearchPath } = createRegistrationPaths(
    { url: eventAttendanceReportPath, request: eventAttendanceReportPath },
    baseParams,
    filterParams
  )

  const menuItems = [
    {
      text: `Take attendance for all participants`,
      href: eventAttendanceReportPath,
      className: attendeeCounts.activeCount === 0 ? "pe-n cn-a c-neutral-400!" : "",
      "data-method": "post"
    },
    {
      text: `Take attendance for these participants (${attendeeCounts.activeCount})`,
      href: attendanceReportSearchPath,
      className: attendeeCounts.activeCount === 0 ? "pe-n cn-a c-neutral-400!" : "",
      "data-method": "post"
    }
  ]

  if (!isSimpleEvent) {
    menuItems.push({ key: "checkins", render: renderCheckIns })
  }

  return (
    <DropdownMenu
      className="btn-outline mb-1 mb-0@sm w-100% w-a@sm mr-1@sm"
      text="Attendance"
      items={menuItems}
    />
  )
}

AttendanceDropdown.propTypes = {
  eventAttendanceReportPath: PropTypes.string,
  attendeeCounts: PropTypes.shape({
    activeCount: PropTypes.number
  }),
  apiBaseUrl: PropTypes.string,
  checkInsBaseUrl: PropTypes.string,
  event: PropTypes.shape({}),
  assignmentTypes: PropTypes.array,
  isSimpleEvent: PropTypes.bool,
  isActingAsStaff: PropTypes.bool,
  baseParams: PropTypes.shape({}),
  filterParams: PropTypes.shape({}),
  subscribedToCheckIns: PropTypes.bool,
  checkInsSettingsPath: PropTypes.string
}

export default AttendanceDropdown
